import React from 'react';
import ReactDOM from 'react-dom';
import './assets/styles/base.css';
import App from './ui/App';
import reportWebVitals from './reportWebVitals';
import i18next from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import {
    HeaderEn,
    HeaderZhCN,
    HomeEn,
    HomeZhCN,
    FooterEn,
    FooterZhCN,
    ContactEn,
    ContactZhCN,
    CompanyEn,
    CompanyZhCN, ServiceEn, ServiceZhCN,
} from "./assets/lang";
import {ConsoleHelper} from "./utils/common";
import dompurify from "dompurify";

dompurify.setConfig({
    ALLOWED_TAGS: ['span', 'a', 'p', 'br', 'strong', 'em'],
    ALLOWED_ATTR: ['class', 'href', 'target', 'rel'],
    FORBID_TAGS: ['script', 'style'],
    FORBID_ATTR: ['onclick', 'onload'],
    ADD_ATTR: ['target'], // Allow target="_blank"
    ADD_TAGS: ['custom-tag'], // If you need custom elements
});

i18next
    .use(I18nextBrowserLanguageDetector)
    .init({
        ns: [
            "translation", "header",
        ],
        defaultNS: "translation",
        fallbackLng: (code) => {
            let fallbacks = [code]
            if (!code || (code.startsWith('zh') && !['zh-HK', 'zh-CN'].includes(code))) {
                fallbacks.push('zh-HK');
            }

            if (!code.includes('en')) {
                fallbacks.push('en');
            }
            return fallbacks;
        },
        resources: {
            en: {
                header: HeaderEn,
                home: HomeEn,
                footer: FooterEn,
                contact: ContactEn,
                company: CompanyEn,
                service: ServiceEn,
            },
            // "zh-HK": {
            //     header: HeaderZhCN,
            // },
            "zh-CN": {
                header: HeaderZhCN,
                home: HomeZhCN,
                footer: FooterZhCN,
                contact: ContactZhCN,
                company: CompanyZhCN,
                service: ServiceZhCN,
            }
        },
        interpolation: {
            escapeValue: false
        }

    }, error => {
        if (!error) {
            //setLang(i18next.language)
            ConsoleHelper("log", "i18n is ready to use!")
        }
    });

ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
